export class WeekObject {
    constructor(public DagNr: number, public Dag: string, public Datum?: any, public Storing?: boolean, public Vertrek?: Date, public Aankomst?: Date, public Pauze?: Date, public Thuis?: Date, public Terug?: Date, public Kilometers?: Number){}
  }


